import React, { FC } from 'react';
import css from './Button.module.scss';

type IProps = {
    children: React.ReactNode
    onClick: any,
}

export const Button: FC<IProps> = ({ children, onClick }: IProps) => (
    <div
        className={css.buttonRoot}
        onClick={onClick}
        role="none"
    >
        <span
            className={`body-l-medium ${css.buttonText}`}
        >
            {children}
        </span>
    </div>
);
